import {
  addDoc, collection, deleteDoc, doc, limit, onSnapshot, orderBy, query, setDoc, Timestamp, where,
} from 'firebase/firestore';
import { db } from '../../firebaseConfig';
import { docsWithId, logListenerError } from '../db';

// Scraper health (Admin → Scraper health). Runs and source status are written by
// packages/scraper; admins write overrides and custom sources. Start a run with triggerScrape().

/** The latest `max` runs, newest first. */
export function subscribeScraperRuns(max, onChange, onError = logListenerError('scraper_runs')) {
  return onSnapshot(query(collection(db, 'scraper_runs'), orderBy('finishedAt', 'desc'), limit(max)),
    (snapshot) => onChange(docsWithId(snapshot)), onError);
}

/** Runs that finished at or after `since` (a Date). */
export function subscribeScraperRunsSince(since, onChange, onError = logListenerError('scraper_runs')) {
  return onSnapshot(query(collection(db, 'scraper_runs'), where('finishedAt', '>=', since)),
    (snapshot) => onChange(docsWithId(snapshot)), onError);
}

/** Per-source result of the latest runs, keyed by source slug. */
export function subscribeScraperSourceStatus(onChange, onError = logListenerError('scraper_source_status')) {
  return onSnapshot(collection(db, 'scraper_source_status'), (snapshot) => onChange(docsWithId(snapshot)), onError);
}

/** Admin overrides as { [slug]: { disabled, name, ... } }. */
export function subscribeScraperOverrides(onChange, onError = logListenerError('scraper_source_overrides')) {
  return onSnapshot(collection(db, 'scraper_source_overrides'),
    (snapshot) => onChange(Object.fromEntries(snapshot.docs.map((snap) => [snap.id, snap.data()]))), onError);
}

/** Turn a built-in source off (or back on) for future runs. */
export function setScraperSourceDisabled({ id, name }, disabled, updatedBy) {
  return setDoc(doc(db, 'scraper_source_overrides', id), {
    disabled, name, updatedAt: Timestamp.now(), updatedBy,
  }, { merge: true });
}

/** Sites added by admins; the scraper crawls them with AI. */
export function subscribeCustomScraperSources(onChange, onError = logListenerError('scraperSources')) {
  return onSnapshot(collection(db, 'scraperSources'), (snapshot) => onChange(docsWithId(snapshot)), onError);
}

export async function addCustomScraperSource({ name, url }, createdBy) {
  const ref = await addDoc(collection(db, 'scraperSources'), { name, url, createdAt: Timestamp.now(), createdBy });
  return ref.id;
}

export function removeCustomScraperSource(id) {
  return deleteDoc(doc(db, 'scraperSources', id));
}
